
/**
 * Description: 输入面板
 * User: 常胤 <satans17@gmail.com>
 * Date: 15/11/8
 * Copyright(c) 2014 Taobao.com
 */
import events from 'events';
import $ from '@ali/tarzan-zepto';
import Voice from '../../../../../lib/voice/voiceinput';
import recordTemplate from './record.html';
import util from '../../../../../lib/util';
import Wave from '../../../../../lib/voice/wave';
import './style.scss';

const STATUS_RECORDING = 'recording';
const STATUS_CANCEL = 'canceling';

const LOG_C = 'inputpanel';

export default class VoiceInput extends events {

  constructor(config) {
    super();
    // get the DOM  avoid the Coupling
    const $target = $(config.trigger);

    this.log = config.log;

    this.$record = $(recordTemplate.render());

    this.__initWave();

    this.voice = this.__voice();

    /**
     * bind event
     */
    this.__bindEvt($target);
    $('body').append(this.$record);
    this.__status = '';
    this.$mask = $('<div class="m-voice-mask"></div>');
    this.$mask.appendTo(document.body);
  }

  __bindEvt($target) {
    let startY = 0;
    let endY = 0;

    /**
     * start voice
     */
    $target.on('touchstart', (ev) => {
      ev.preventDefault();
      $target.removeClass('press-speech').addClass('loosen-speech');
      this.voice.start();
      startY = ev.touches[0].pageY;
      this.log.send({
        c: LOG_C,
        d: 'voice_press',
      });
    });

    /*
     voice cancel listener
     */
    $target.on('touchmove', (ev) => {
      const nowY = ev.touches[0].pageY;

      if (nowY - startY < -60) {
        this.setStatusAs(STATUS_CANCEL);
        $target.removeClass('loosen-speech').addClass('press-speech');
      } else {
        this.setStatusAs(STATUS_RECORDING);
        $target.removeClass('press-speech').addClass('loosen-speech');
      }
    });

    /*
     end vocie
     */
    $target.on('touchend', (ev) => {
      $target.addClass('press-speech').removeClass('loosen-speech');

      endY = ev.changedTouches[0].pageY;

      // 如果向上滑动距离大于60，不发送消息
      if (endY - startY > -60) {
        setTimeout(() => {
          this.voice.end();
        }, 300);
        this.log.send({
          c: LOG_C,
          d: 'voice_loosen',
        });
      } else {
        this.voice.cancel();
        this.log.send({
          c: LOG_C,
          d: 'voice_cancel',
        });
      }
    });
  }

  __voice() {
    const voice = new Voice();
    let hasCancel = false;

    voice.on('start', () => {
      this.showRecord();
      this.emit('voicestart');
    });

    voice.on('end', () => {
      this.hideRecord();
      hasCancel = false;
    });

    voice.on('cancel', () => {
      this.hideRecord();
      this.emit('voicecancel');
      hasCancel = true;
    });

    voice.on('startError', () => {
      this.hideRecord();
      this.emit('voicecancel');
    });

    voice.on('endError', () => {
      this.hideRecord();
      this.emit('voicecancel');
    });

    voice.on('result', (ev) => {
      if (hasCancel) {
        hasCancel = false;
        return;
      }

      this.emit('input', ev);
      this.hideRecord();
    });

    voice.on('volume', (volume) => {
      this.pushWave(volume);
    });

    return voice;
  }

  __initWave() {
    this.rightWave = new Wave({
      el: this.$record.find('.right-wave'),
    });

    this.leftWave = new Wave({
      el: this.$record.find('.left-wave'),
      direction: 'left',
    });

    // const CLS = ['icon-num-one', 'icon-num-two',
    //   'icon-num-three', 'icon-num-four', 'icon-num-five'];
    // const $count = this.$record.find('.count-down');
    // this.leftWave.on('count', (remain) => {
    //   // 倒计时结束以后主动停止语音获取.否则可能出现识别内容为空的情况.
    //   if (remain <= 0) {
    //     this.voice.end();
    //     $count.hide();
    //   } else if (remain <= 5 && remain > 0) {
    //     $count.removeClass(CLS.join(' '))
    //       .addClass(CLS[remain - 1])
    //       .show();
    //   } else {
    //     $count.hide();
    //   }
    // });
  }

  startWave() {
    this.leftWave.start();
    this.rightWave.start();
  }

  stopWave() {
    this.leftWave.stop();
    this.rightWave.stop();
  }

  pushWave(v) {
    this.leftWave.push(v);
    this.rightWave.push(v);
  }

  // 显示音量
  showRecord() {
    this.startWave();
    this.$record.show();
    this.$mask.show();
    util.later(() => {
      this.setStatusAs(STATUS_RECORDING);
    }, 100);
  }

  // 隐藏识别
  hideRecord() {
    this.stopWave();
    util.later(() => {
      this.setStatusAs('');
      this.$record.hide();
      this.$mask.hide();
    }, 100);
  }

  setStatusAs(status) {
    this.$record.removeClass(this.__status).addClass(status);
    this.__status = status;
  }

}



// WEBPACK FOOTER //
// ./src/component/view/footer/input/voice/index.js